import AnnotationCC from "../../api/AnnotationCommunicationController";

export enum MediaType {
    IMAGE = "image",
    VIDEO = "video"
}

export type StatsKeys = "image" | "video";

export type MediaStats = Record<StatsKeys, number> & {
    joints: {
        [key: string]: Record<StatsKeys, number> & {
            scans: {
                [key: string]: Record<StatsKeys, number>;
            };
        };
    };
};

export const isDatasetValid = (data: DatasetData): boolean => {
    return data.name.trim() !== "";
};

export class DatasetData {
    name: string = "";
    description: string = "";
    type: MediaType = MediaType.IMAGE;
    // La lista di ID dei media da includere nel dataset (§413): opzionale per
    // l'utente (può creare un dataset vuoto), ma il campo va sempre inviato al
    // server, anche vuoto — da qui il default a [] invece che undefined.
    media: number[] = [];
}

export type DatasetDataKey = keyof DatasetData;

export default class Dataset {
    id: number;
    name: string;
    description: string;
    start_date?: string;
    end_date?: string;
    type: MediaType;
    media_cnt: number;

    constructor(obj: Dataset) {
        this.id = obj.id;
        this.name = obj.name;
        this.description = obj.description;
        this.start_date = obj.start_date;
        this.end_date = obj.end_date;
        this.type = obj.type;
        this.media_cnt = obj.media_cnt ?? 0;
    }

    typeStr = () => {
        switch (this.type) {
            case MediaType.IMAGE:
                return "Immagini";
            case MediaType.VIDEO:
                return "Video";
            default:
                return "Unknown";
        }
    };

    filter = (filter: string): boolean => {
        filter = filter.toLowerCase();
        return this.name.toLowerCase().includes(filter) || this.description.toLowerCase().includes(filter);
    };

    // GET /dataset/:id, con i media inclusi (§421) — risposta grezza, pensata per
    // essere scaricata direttamente come file, non per costruire un altro Dataset.
    download = (): Promise<any> => {
        return AnnotationCC.getDataset(this.id);
    };
}
